var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":_vm.title,"width":"10cm","destroyOnClose":true,"maskClosable":false,"footer":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('Calculator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }